<template>
  <div class="pagination-container">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[15, 20, 30]"
      :page-size="limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val)
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-pagination {
  .el-pager li:hover {
    color: #d04247;
  }
  .el-pager {
    .number {
      color: #858585;
      cursor: pointer;
      transition: all 0.4s;
    }

    .number.active {
      color: #d04247;
    }
  }
}
</style>
